module.exports = [{
      plugin: require('/Users/cog/node-code/Yida/testing-starter-blog-at-YidaCNC.github.io/YidaCNC.github.io/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/cog/node-code/Yida/testing-starter-blog-at-YidaCNC.github.io/YidaCNC.github.io/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/cog/node-code/Yida/testing-starter-blog-at-YidaCNC.github.io/YidaCNC.github.io/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/Users/cog/node-code/Yida/testing-starter-blog-at-YidaCNC.github.io/YidaCNC.github.io/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
